import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setPrincipal = info => {
	return {
		type: ActionTypes.LOAD_PRINCIPAL,
		principal: info.data
	};
};

export const loadPrincipal = () => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/solanasapi/principal")
			.then(response => {
				dispatch(setPrincipal(response.data));
			})
			.catch(error => {});
	};
};

export const savePrincipal = (promotion, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.update(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/solanasapi/principal/",
				promotion,
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				dispatch(loadPrincipal());
			})
			.catch(error => {});
	};
};

export const createPrincipal = (principal, token, imageUrl) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/solanasapi/principal/",
				{
					titulo: principal.titulo,
					descripcion: principal.descripcion,
					seccion: principal.seccion,
					imagen: imageUrl
				},
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				dispatch(loadPrincipal());
			})
			.catch(error => {});
	};
};

export const uploadImageAndCreatePrincipal = (principal, token) => {
	const formData = new FormData();
	formData.append("myImage", principal.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(createPrincipal(principal, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const deletePrincipal = (principal, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.delete(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/solanasapi/principal/" +
					principal.id,
				{
					headers: { Authorization: AuthStr }
				},
				{ data: principal }
			)
			.then(response => {
				dispatch(loadPrincipal());
			})
			.catch(error => {});
	};
};
